import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  dashboardAllData,
  dashboardBrand,
  dashboardCategory,
  dashboardData,
  dashboardPriceChanges,
  dashboardPriceRank,
} from "./dashboard.thunk";

const INIT_STATE = {
  dashboard: {},
  brand: {},
  category: {},
  priceRank: {},
  pieData: [],
  priceChange: -1,
  rangePriceChange: -1,
  selLocation: [],
  loading: true,
};

export const fetchDashboardDataAsyncThunk = createAsyncThunk(
  "fetchDashboardData",
  dashboardData
);

export const fetchDashboardBrandAsyncThunk = createAsyncThunk(
  "fetchDashboardBrand",
  dashboardBrand
);

export const fetchDashboardCategoryAsyncThunk = createAsyncThunk(
  "fetchDashboardCategory",
  dashboardCategory
);

export const fetchDashboardPriceRankAsyncThunk = createAsyncThunk(
  "fetchDashboardPriceRank",
  dashboardPriceRank
);

export const fetchPriceChangeAsyncThunk = createAsyncThunk(
  "fetchPriceChanges",
  dashboardPriceChanges
);

export const fetchDashboardAllDataAsyncThunk = createAsyncThunk(
  "fetchDashboardAllData",
  dashboardAllData
);

const dashboardSlice = createSlice({
  name: "dashboard data",
  initialState: INIT_STATE,
  reducers: {
    setDashboardData: (state, action) => {
      state.dashboard = action.payload;
    },
    setDashboardBrand: (state, action) => {
      state.brand = action.payload;
    },
    setDashboardCategory: (state, action) => {
      state.category = action.payload;
    },
    setDashboardPriceRank: (state, action) => {
      state.priceRank = action.payload;
    },
    setRangePriceChange: (state, action) => {
      state.rangePriceChange = action.payload;
    },
    setPriceChange: (state, action) => {
      state.priceChange = action.payload;
    },
    setPieData: (state, action) => {
      let data = [];
      data.push(
        {
          name: "Expensive",
          value: Number(action.payload.expensiveProducts),
          color: "#ff9999",
        },
        {
          name: "Midrange",
          value: Number(action.payload.midrangeProducts),
          color: "#ffffb7",
        },
        {
          name: "Cheapest",
          value: Number(action.payload.cheapestProducts),
          color: "#a3d9c5",
        }
      );
      state.pieData = data;
    },
    setSelLocation: (state, action) => {
      state.selLocation = action.payload;
    },

    setDashboardAllData: (state, action) => {
      const allData = action.payload;
      state.dashboard = allData.stats;
      state.brand = allData.brand_stats;
      state.category = allData.category_stats;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardDataAsyncThunk.pending, (state) => {
        return state;
      })
      .addCase(fetchDashboardDataAsyncThunk.fulfilled, (state) => {
        return state;
      })
      .addCase(fetchDashboardDataAsyncThunk.rejected, (state) => {
        return state;
      })
      .addCase(fetchDashboardBrandAsyncThunk.pending, (state) => {
        return state;
      })
      .addCase(fetchDashboardBrandAsyncThunk.fulfilled, (state) => {
        return state;
      })
      .addCase(fetchDashboardBrandAsyncThunk.rejected, (state) => {
        return state;
      })
      .addCase(fetchDashboardCategoryAsyncThunk.pending, (state) => {
        return state;
      })
      .addCase(fetchDashboardCategoryAsyncThunk.fulfilled, (state) => {
        return state;
      })
      .addCase(fetchDashboardCategoryAsyncThunk.rejected, (state) => {
        return state;
      })
      .addCase(fetchDashboardPriceRankAsyncThunk.pending, (state) => {
        return state;
      })
      .addCase(fetchDashboardPriceRankAsyncThunk.fulfilled, (state) => {
        return state;
      })
      .addCase(fetchDashboardPriceRankAsyncThunk.rejected, (state) => {
        return state;
      })
      .addCase(fetchPriceChangeAsyncThunk.pending, (state) => {
        return state;
      })
      .addCase(fetchPriceChangeAsyncThunk.fulfilled, (state) => {
        return state;
      })
      .addCase(fetchPriceChangeAsyncThunk.rejected, (state) => {
        return state;
      })
      .addCase(fetchDashboardAllDataAsyncThunk.pending, (state) => {
        state.loading = true;
        return state;
      })
      .addCase(fetchDashboardAllDataAsyncThunk.fulfilled, (state) => {
        state.loading = false;
        return state;
      })
      .addCase(fetchDashboardAllDataAsyncThunk.rejected, (state) => {
        state.loading = false;
        return state;
      });
  },
});

export const {
  setDashboardData,
  setDashboardBrand,
  setDashboardCategory,
  setDashboardPriceRank,
  setPieData,
  setPriceChange,
  setRangePriceChange,
  setSelLocation,
  setDashboardAllData,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
